"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variant = void 0;
var Variant;
(function (Variant) {
    Variant["ExperienceVoucher"] = "experience_voucher";
    Variant["ExperienceTicket"] = "experience_ticket";
    Variant["BookingType"] = "booking_type";
    Variant["Box"] = "box";
    Variant["ValueVoucher"] = "value_voucher";
    Variant["GiftWrap"] = "gift_wrap";
})(Variant || (exports.Variant = Variant = {}));
//# sourceMappingURL=Variant.js.map